import { isInAndroidWebView, isInIOSWebView } from '@shared/george-go';

type ApplicationType = 'george-android' | 'george-ios' | 'george-web';

export const getApplicationType = (): ApplicationType => {
    if (isInIOSWebView()) {
        return 'george-ios';
    }

    if (isInAndroidWebView()) {
        return 'george-android';
    }

    return 'george-web';
};
